import React, { useState, useEffect, useContext } from "react";
import { PartenerSheepDeedService } from "../services/parternshipservice";
import CitySelector from "./User/CitySelectore";
import { useNavigate } from "react-router-dom";
import { handleRazorpayPayment } from "../services/handlePayment";
import AuthUser from "../services/AuthUser";
import { ServicesContext } from "../services/ServicesContext";

const PricingPlan2 = ({ tenures, duration, requirements, price, inclusions, title, onSubmit }) => {

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setNewData((prevData) => ({
        ...prevData,
        user_name: parsedUser.name || "",
        user_email: parsedUser.email || "",
        user_contact: parsedUser.mobile || "",
        user_city: parsedUser.city || "",
      }));
    }
  }, []);


       const { http, token } = AuthUser();
   const navigate = useNavigate();
  const { services, loading, error } = useContext(ServicesContext);
  const service = services.find(s => s.service_id === 15);
  console.log(title, price);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedTenure, setSelectedTenure] = useState(null);
  const [isFormVisible, setIsFormVisible] = useState(false); // Track if the form is visible
  const [isContentVisible, setIsContentVisible] = useState(true); // Track if the bottom content is visible

  const toggleDropdown = () => setIsDropdownOpen((prev) => !prev);

  const selectTenure = (tenure) => {
    setSelectedTenure(tenure);
    setIsDropdownOpen(false);  // Close dropdown after selection
  };

  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.closest('.dropdown') === null) {
        setIsDropdownOpen(false);  // Close dropdown when clicking outside
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleGetStartedClick = () => {
    setIsFormVisible(true);  // Show the form when "Get Started" button is clicked
    setIsContentVisible(false);  // Hide content at the bottom
  };

  const handleCloseClick = () => {
    setIsFormVisible(false);  // Hide the form when "Close" button is clicked
    setIsContentVisible(true);  // Show content at the bottom
  };



  const [newData, setNewData] = useState({ plans: title, prize: price, user_name: '', user_email: '', user_contact: '', user_city: '' })

  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};



    if (!newData.user_name.trim()) {
      newErrors.user_name = '*Name is required.';
    } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
      newErrors.user_name = '*Name should only contain letters and spaces.';
    }

    if (!newData.user_email.trim()) {
      newErrors.user_email = '*Email is required.';
    } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
      newErrors.user_email = 'Enter a valid email address.';
    }

        if (!newData.user_contact.trim()) {
      newErrors.user_contact = '*number is required.';
    } else if (!/^\d{10}$/.test(newData.user_contact)) {
      newErrors.user_contact = 'Enter a valid 10-digit contact number.';
    }

    // if (newData.user_contact && !/^\d{10}$/.test(newData.user_contact)) {
    //   newErrors.user_contact = '*Enter a valid 10-digit contact number.';
    // }

    if (!newData.user_city) {
      newErrors.user_city = '*City/District is required.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // No errors
  };
  const currentData = {
    plans: title,
    prize: price,
    user_name: newData.user_name,
    user_email: newData.user_email,
    user_contact: newData.user_contact,
    user_city: newData.user_city,
  };


  const handleSubmit = async (e) => {



    e.preventDefault();
    // ✅ Check if user is logged in
  //   if (!token) {
  //      alert("Please log in to continue.");
  //        localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
  //     navigate('/login'); // 👈 Use this if you're using React Router
  //     return;
  //  }

    // if (validateForm()) {
    //   try {
    //  // Prevent form default behavior
    // const currentData = {
    //   plans: title,
    //   prize: price,
    //   user_name: newData.user_name,
    //   user_email: newData.user_email,
    //   user_contact: newData.user_contact,
    //   user_city: newData.user_city,
    // };
    // console.log("Submitting data:", currentData);
    // const data = await PartenerSheepDeedService.gstReturnForm(currentData);
    //     // Reset form
    //     setNewData({
    //       plans: title,
    //       prize: price,
    //       user_name: '',
    //       user_email: '',
    //       user_contact: '',
    //       user_city: '',
    //     });

    if (!validateForm()) return;

 localStorage.setItem("bookingData", JSON.stringify(currentData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });



    if (onSubmit) {
      onSubmit(currentData); // Pass the constructed data to the parent
    }





  };





  // const formPutPartenshipdeed = async (e) => {
  //   e.preventDefault();
  //   if (!validateForm()) return;

  //   await handleRazorpayPayment({
  //     service,
  //     userData: newData,
  //     http, // ✅ Pass this from the component
  //     fieldMap: {
  //       email: newData.user_email ? 'user_email' : 'user_email_address',
  //       contact: newData.user_contact ? 'user_contact' : 'user_phone_number',
  //       name: newData.user_name ? 'user_name' : 'full_name'
  //     }
  //     ,
  //     formSubmitCallback: async (mergedData) => {
  //       await PartenerSheepDeedService.legalNoticeForm(mergedData);
  //       setNewData({
  //         user_name: '',
  //         user_email_address: '',
  //         user_phone_number: '',
  //         user_related_query: '',
  //       });
  //     },
  //   });

  // };

  return (
    <div className="pricing-plan">
      <div className="price">
        <p className="pp-text">{title}</p>
        {isFormVisible && (
          <div class="wrapper">

            <button
              className="getStartdBn btn"
              onClick={isFormVisible ? handleCloseClick : handleGetStartedClick}
            >
              {isFormVisible ? "Close" : "Get Started"}
            </button>


          </div>
        )}

      </div>

      <p className="price-section">
        <span></span>Rs.{price}
        {/* <span>/{duration}</span> */}
      </p>

      {/* Display form only when "Get Started" button is clicked */}
      {isFormVisible && (
        <div className="formContainer">
          <form>
            <div className="form-group">
              <label className="text-bold" htmlFor="name">Name</label>{errors.user_name && <p className="error">{errors.user_name}</p>}
              <input type="text" className="form-control" required value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="text-bold" htmlFor="email">Email</label> {errors.user_email && <p className="error">{errors.user_email}</p>}
              <input type="email" className="form-control" required value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
            </div>
            <div className="form-group">
              <label className="text-bold" htmlFor="mobile">Contact no</label> {errors.user_contact && <p className="error">{errors.user_contact}</p>}
              <input type="tel" className="form-control" required value={newData.user_contact} onChange={(e) => setNewData({ ...newData, user_contact: e.target.value })} />
            </div>
            <div className="form-group">
              <CitySelector
                newData={newData}
                setNewData={setNewData}
                fieldKey="user_city"
                errors={errors}
              />
            </div>

            <div class="wrapper">
              <button type="submit" className="getStartdBn btn" onClick={handleSubmit}>
                Submit
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Show content only when it's visible */}
      {isContentVisible && (
        <div className="yttt">
          <div className="defaultText">

            <p className="text-bold"><i className="fa fa-star icone"></i> Requirements:-</p>
            <p className="text-bold"> Accounitng Software Genrated-</p>
            <ul>
              {requirements.map((item, index) => (
                <li key={index} className="text-bold"><i className="fa fa-circle icone"></i> {item}</li>
              ))}
            </ul>

            <p className="text-bold"><i className="fa fa-star icone"></i> Inclusions:-</p>
            <ul>
              {inclusions.map((item, index) => (
                <li key={index} className="text-bold"><img src="assets/icons/check.svg" alt="" /> {item}</li>
              ))}
            </ul>
            <p className="text-bold"> Note : If Invoice Quantity or Turnover crosses limit of plan then upgrade will be required.</p>
          </div>
          <div class="wrapper">

            <button
              className="getStartdBn btn"
              onClick={isFormVisible ? handleCloseClick : handleGetStartedClick}
            >
              {isFormVisible ? "X" : "Get Started"}
            </button>


          </div>
        </div>
      )}
    </div>
  );
};

export default PricingPlan2;
